import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, finalize, tap } from 'rxjs';
import { EmailConfirmationService } from '@pages/email-confirmation/services/email-confirmation.service';
import { ConfirmEmail, ConfirmEmailSuccess } from '@pages/email-confirmation/store/actions/email-confirmation.actions';

export interface EmailConfirmationStateModel {
  loading: boolean;
}

@State<EmailConfirmationStateModel>({
  name: 'emailConfirmation',
  defaults: {
    loading: false,
  },
})
@Injectable()
export class EmailConfirmationState {
  private readonly emailConfirmationService = inject(EmailConfirmationService);

  @Selector()
  static loading(state: EmailConfirmationStateModel): boolean {
    return state.loading;
  }

  @Action(ConfirmEmail)
  confirmEmail(context: StateContext<EmailConfirmationStateModel>, { token }: ConfirmEmail): Observable<void> {
    context.patchState({ loading: true });
    return this.emailConfirmationService.confirmEmail(token).pipe(
      tap(() => context.dispatch(new ConfirmEmailSuccess())),
      finalize(() => context.patchState({ loading: false }))
    );
  }
}
